import axios from 'axios'

export default {
  namespaced: true,
  state: {
    topic: {
      topic_id: null,
      topic_name: null,
      information_text: null,
      topic_image_url: null,
      tags: null,
      updated_at: null,
      topic_type: null,
      topic_parts: [],
      tagSelect: [],
    }
  },
  getters: {
    getTopicState: (state) => state.topic
  },
  mutations: {
    setTopicState(state, data) {
      state.topic.topic_id = data.topic_id;
      state.topic.topic_name = data.topic_name;
      state.topic.information_text = data.information_text;
      state.topic.topic_image_url = data.topic_image_url;
      state.topic.tags = data.tags;
      state.topic.updated_at = data.updated_at;
      state.topic.topic_type = data.topic_type;
      state.topic.topic_parts = data.topic_parts;
      state.topic.tagSelect = data.tagSelect;
    },
  },
  actions: {
    async delete(context, id) {
      await axios.delete(process.env.VUE_APP_API_BASE_URL + '/topic/' + id)
    },
    setTopicState({commit}, data) {
      commit('setTopicState', data);
    },
  },
}